import JILIFISHActions from './JILIFISHActions'

export default class ACEWINFISHActions extends JILIFISHActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'FH',
      gameName: 'SuperStar',
      gameCode: 'ACEWIN-FISH-001',
      platform: 'ACEWIN',
    }

    // txnId & roundId: 100012287986
    // betTime: 2025-08-26T17:34:29.000+08:00
  }
}
